import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

export default function UpgradeListing() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const listinguid = params.get("listinguid");

    const localUser = JSON.parse(localStorage.getItem("user"));
    const personaluid = localUser?.personaluid;

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([]);
    const [promotionDays, setPromotionDays] = useState(0);
    const [loading, setLoading] = useState(false);

    // Load packages from API
    useEffect(() => {
        fetch(`${API_BASE}/api/get_packages.php`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setOptions(data.packages);
                }
            });
    }, []);

    const toggleSelect = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const promotionPrice = options.find(p => p.title === "Promotion")?.price || 0;

    const finalAmount =
        selected.reduce((sum, id) => {
            const opt = options.find((o) => o.id === id);
            return sum + (opt?.price || 0);
        }, 0) + promotionDays * promotionPrice;

    const handleProceed = async () => {
        if (selected.length === 0 && promotionDays === 0) {
            alert("Select at least one upgrade option.");
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(`${API_BASE}/api/generate_fonepay_payment.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    listinguid,
                    selected_plans: selected,
                    promotion_days: promotionDays,
                    total_amount: finalAmount,
                    user_id: personaluid,
                }),
            });

            const data = await res.json();
            setLoading(false);

            if (data.success && data.payment_url) {
                window.location.href = data.payment_url;
            } else {
                alert(data.message || "Payment initialization failed");
            }
        } catch (err) {
            setLoading(false);
            alert("Network error");
        }
    };

    const planOptions = options.filter(opt => opt.title !== "Promotion");

    // Array of subtle background colors
    const bgColors = ["#f8f9fa", "#e8f0fe", "#fef7e8", "#e8fdf5", "#fde8f0"];

    return (
        <div className="container py-4">
            <h3 className="fw-bold text-center mb-4" style={{ color: "#333" }}>
                Upgrade Your Listing
            </h3>
            <p className="text-center text-secondary mb-4">
                Choose premium services to boost your visibility and trust.
            </p>

            <div className="row g-3">
                {planOptions.length === 0 ? (
                    <div className="col-12 text-center text-muted">No packages available</div>
                ) : (
                    planOptions.map((plan, idx) => (
                        <div className="col-md-6 col-sm-12" key={plan.id}>
                            <div
                                className={`card h-100 shadow-sm border-0 ${selected.includes(plan.id) ? "border-primary" : ""
                                    }`}
                                style={{
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    minHeight: "150px",
                                    background: bgColors[idx % bgColors.length],
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                                onClick={() => toggleSelect(plan.id)}
                            >
                                <div className="card-body d-flex flex-column justify-content-between">
                                    <div>
                                        <h6 className="fw-bold">{plan.title}</h6>
                                        <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
                                            {plan.description}
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                        <span className="fw-bold text-primary">₹ {plan.price}</span>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={selected.includes(plan.id)}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}

                {/* Promotion Card */}
                <div className="col-md-6 col-sm-12">
                    <div
                        className="card h-100 shadow-sm border-0"
                        style={{
                            borderRadius: "10px",
                            minHeight: "150px",
                            background: "#fff7e8",
                        }}
                    >
                        <div className="card-body d-flex flex-column justify-content-between">
                            <h6 className="fw-bold">Promotion Per Day 📢</h6>
                            <p className="text-muted mb-2">₹ {promotionPrice} per day</p>
                            <input
                                type="number"
                                className="form-control"
                                min="0"
                                value={promotionDays}
                                onChange={(e) => setPromotionDays(Number(e.target.value))}
                                placeholder="Enter days"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Total Amount */}
            <div className="card shadow-sm mt-4 rounded-4">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold m-0">Total Amount:</h5>
                    <h4 className="m-0 text-primary">₹ {finalAmount}</h4>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex justify-content-between mt-4 gap-3">
                <button
                    className="btn btn-outline-warning w-50 py-2"
                    onClick={() => navigate(`/admin?userid=${personaluid}`)}
                >
                    ← Back
                </button>
                <button
                    className="btn btn-primary w-50 py-2 fw-semibold"
                    onClick={handleProceed}
                    disabled={loading}
                >
                    {loading ? "Processing..." : "Proceed to Payment"}
                </button>
            </div>

            <style>{`
                .border-primary {
                    border: 2px solid #4a90e2 !important;
                }
                .card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
                }
            `}</style>
        </div>
    );
}
